import { RequestIdGenerator } from '@babylon/shared-utils'
import { setRequestIdGenerator } from '@babylon/babylon-auth'

const requestIdGenerator = new RequestIdGenerator({ app: 'ap2' })

setRequestIdGenerator(requestIdGenerator)

export default requestIdGenerator
